import request from '../../axios';

const getInputGroupList = async () => {
  const {data}: {data: IInputGropuList[]} = await request.get(
    '/api/v2/store/input-group-list',
  );

  return data;
};

export default getInputGroupList;
